import React from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Home from "./Home";
import Clinic from "./Studies/Clinic";
import Teleconsulation from "./Studies/Teleconsulation";
import StudyEdit from "./Studies/Clinic/Edit";
import StudyRespond from "./Studies/Teleconsulation/Respond";
import StudyAddendum from "./Studies/Teleconsulation/Addendum";
import StudyConsult from "./Studies/Clinic/Consult";
import ScheduleCalendar from "./Schedule";
import ModalityScheduleCalendar from "./Schedule/ModalityScheduleCalendar";

import Import from "./Studies/Import";
import StudyNew from "./Studies/New";

const Dashboard = ({ user, access, socketStatus, hasSchedule, hasModalitySchedule }) => {

  const navigate = useNavigate();
  const location = useLocation();
  React.useEffect(() => {
    const loc = location.pathname.substring(1).split('/')
    if (loc.length) {
        if ((loc[0] === 'clinic' && !access.clinic) || (loc[0] === 'consult' && !access.consult))
          navigate('/', { replace: true })
    }
  }, [location, access, navigate])

  return (
    <Routes>
      <Route path="/schedule" element={<ScheduleCalendar access={access} hasSchedule={hasSchedule} socketStatus={socketStatus} />} />
      <Route path="/modality-schedule" element={hasModalitySchedule ? <ModalityScheduleCalendar access={access} socketStatus={socketStatus} /> : null} />
      <Route path="/import" element={<Import access={access} />} />
      <Route path="/new" element={<StudyNew access={access} />} />
      <Route path="/new-consult" element={<StudyNew access={access} />} />
      <Route path="/mobile-consult" element={<StudyNew access={access} mobile />} />
      <Route path="/imaging-consult" element={<StudyNew access={access} imaging />} />
      <Route path="/studies/:studyId/consult" element={<StudyConsult user={user} access={access} />} />
      <Route path="/studies/:studyId/consult/edit" element={<StudyConsult user={user} access={access} edit={true} />} />
      <Route path="/studies/:studyId/respond" access={access} element={<StudyRespond />} />
      <Route path="/studies/:studyId/addendum" element={<StudyAddendum />} />

      <Route path="/studies/:studyId/media" element={<StudyAddendum />} />
      <Route path="/studies/:studyId" element={<StudyEdit />} />
      <Route
        path="/clinic"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/clinic/today"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" filter="today" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/clinic/yesterday"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" filter="yesterday" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/clinic/week"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" filter="week" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/clinic/all"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/clinic/attention"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" filter="attention" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/clinic/pending"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" filter="pending" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/clinic/complete"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" filter="complete" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/clinic/scheduled"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" filter="scheduled" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/clinic/unscheduled"
        element={<Clinic user={user} access={access} socketStatus={socketStatus} view="clinic" filter="unscheduled" hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />}
      />
      <Route
        path="/consult"
        element={<Teleconsulation user={user} access={access} socketStatus={socketStatus} view="consult" />}
      />
      <Route
        path="/consult/pending-unclaimed"
        element={
          <Teleconsulation user={user} access={access} socketStatus={socketStatus} view="consult" filter="pending-unclaimed" />
        }
      />
      <Route
        path="/consult/pending-claimed"
        element={
          <Teleconsulation user={user} access={access} socketStatus={socketStatus} view="consult" filter="pending-claimed" />
        }
      />
      <Route
        path="/consult/pending-available"
        element={
          <Teleconsulation user={user} access={access} socketStatus={socketStatus} view="consult" filter="pending-available" />
        }
      />
      <Route
        path="/consult/pending"
        element={
          <Teleconsulation user={user} access={access} socketStatus={socketStatus} view="consult" filter="pending" />
        }
      />
      <Route
        path="/consult/complete"
        element={
          <Teleconsulation user={user} access={access} socketStatus={socketStatus} view="consult" filter="complete" />
        }
      />
      <Route
        path="/consult/complete-claimed"
        element={
          <Teleconsulation user={user} access={access} socketStatus={socketStatus} view="consult" filter="complete-claimed" />
        }
      />
      <Route
        path="/consult/prelim"
        element={
          <Teleconsulation user={user} access={access} socketStatus={socketStatus} view="consult" filter="prelim" />
        }
      />
      <Route path="/" element={<Home user={user} access={access} />} />
    </Routes>
  );
};

export default Dashboard;
